const CHECKBOX_UNCHECKED_LIST = [
  { variant: 'default', label: 'Default' },
  { variant: 'hover', label: 'Hover' },
  { variant: 'active', label: 'Active' },
  { variant: 'focus', label: 'Focus' },
  { variant: 'disabled', label: 'Disabled', disabled: true }
]

export default CHECKBOX_UNCHECKED_LIST
